import { SET_DASHBOARD_STATE } from "../constants/dashboardLabelConstants";

const initialState = {
    dashboardState: 'disabled', // Default to prevent null or undefined
};

export const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DASHBOARD_STATE:
            return {
                ...state,
                dashboardState: action.payload || 'disabled', // Fallback to default if payload is empty
            };
        default:
            return state;
    }
};
